export class SKU {

    constructor(
        public id: string,
        public price: number | null,
        public onSale: boolean
    ) { }
}

export type PricedSKU = SKU & { price: number }
